import { Selection } from "d3";
import { CalendarSizeDimensions } from "svg/constants";

const drawErrorPage = (
    base: Selection<any, any, any, any>,
    calendarDimensions: CalendarSizeDimensions,
) => {
    base.html("");

    base.append("svg")
        .attr("width", "100%")
        .attr("height", "100%")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .style("background-color", "red");
};

export { drawErrorPage };
